import React, { Component } from 'react';
import {
  Text,
  View,
  TextInput,
  Dimensions,
  TouchableHighlight,
  Linking,
  Image,
  Picker,
  Platform,
  ActivityIndicator,
  ScrollView,
} from 'react-native';
import {StyleContext} from '../styleC';
import info from '../info';
import strings from '../strings';
import MavButton from './mavButton';
import colorList from '../colorList';
import TextPresentation from './textPresentation';
const timer = require('react-native-timer');
import Modal from './modal';
import firebase from './firebase';
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { getDatabase, ref, set, update, remove, get, onValue, child, orderByChild, orderByValue, limitToFirst, startAt, endAt, query} from "firebase/database";

import MavAlert from './mavAlert';

export default class mavAlert extends Component {
  state = {
    modalVisible: false,
    textInput:"",
    title:"",
    subTitle:"",
    largeButton:false,
    code:"",
    items:[], 
    itemSelected:-1,
    buttons:[{text: strings.ok,onPress: () => {}}],
    maxiMode:false,
    notSelectable:false,
    drawerMini:false, 
    arrowQuestion:false,
    arrowQuestions:false,
    arrowEnabled:false,
    help:false,
    check:false,
    view:"basic", 
    colorList:[],
    choiceColor:false,
    notClose:false,
    waiting:true,
    vtcList:[],
    taxiList:[], 



  };
componentDidMount(){



}



  list(value){
    this.setState({modalVisible:true, waiting:true})

      /*je récupère la liste des chauffeurs */
    var rqPart={
        uuid:getAuth(firebase).currentUser.uid,
        viewAllPartners:(this.props.driver==true)?true:false,
        zoneTaxi:value.idTaxi,
        zoneVTC:value.idVTC,
        listDriver:true, 
    }
    
    if(this.props.driverPositionPrecise==true) rqPart.driverPositionPrecise=true;
    if(this.props.orderDriver==true) rqPart.orderDriver=true;
    if(value.idTaxi!="" && this.props.orderDriver==true && this.props.priorizationTaxi==true) rqPart.priorizationTaxi=true; 

  console.log("je fais la requete")
  console.log(rqPart)


 
  fetch("https://us-central1-"+info.firebaseProjectID+".cloudfunctions.net/getPartner", {
        body: JSON.stringify(rqPart),
        headers: {"Content-Type": "application/json"},method: "POST"}).then((response) => response.json())
                  .then((responseJson) => {
                    console.log("partner")
                    console.log(responseJson)

                    if(responseJson.length==0) this.setState({modalVisible:false, waiting:false},() =>{this.alert.onAlert({title:strings.nothingToView})}) 
                    else {
                        /*je trie VTC et taxi */
                        var vtcList=[]
                        var taxiList=[]

                        var i; 
                        for(i=0; i<responseJson.length;i++){
                          if(responseJson[i].isTaxi!=false) taxiList.push(responseJson[i])
                          if(responseJson[i].isVTC!=false) vtcList.push(responseJson[i])
                        }

                      if(rqPart.orderDriver==true) taxiList.sort(function(a, b){
                        if(a.rankTaxi < b.rankTaxi) return -1;
                        if(a.rankTaxi > b.rankTaxi) return 1;
                        return 0;
                      })

                      if(rqPart.orderDriver==true) vtcList.sort(function(a, b){
                          if(a.rank < b.rank) return -1;
                          if(a.rank > b.rank) return 1;
                          return 0;
                      })

                      this.setState({vtcList:vtcList, taxiList:taxiList,waiting:false})

                    }

                  })



    
  }

  render() {
    return (
      <StyleContext.Consumer>{style => <View>
    


     <Modal
          animationType="none"
          transparent={true}
          visible={this.state.modalVisible}>
          <View style={{height:Dimensions.get('window').height,width:Dimensions.get('window').width,position:"absolute",justifyContent:"center"}}>

              <TouchableHighlight underlayColor={"rgba(0,0,0,0.5)"} style={{height:Dimensions.get('window').height,width:Dimensions.get('window').width,backgroundColor:"rgba(0,0,0,0.5)",position:"absolute",marginTop:0}} onPress={() => {this.setState({modalVisible:false}) }}>
                  <View/>
              </TouchableHighlight>

              {this.state.waiting==true && <ActivityIndicator style={{marginTop:40,marginBottom:5}} size="large" color={style.color1} />}


              {this.state.waiting==false && <ScrollView style={{width:(Dimensions.get('window').width>style.mobileSizeMax)?style.minimizeWidth:(Dimensions.get('window').width*0.8), height:Dimensions.get('window').height*0.8,backgroundColor:style.backgroundColor,position:"absolute",marginLeft:(Dimensions.get('window').width>style.mobileSizeMax)?((Dimensions.get('window').width-style.minimizeWidth)/2):(Dimensions.get('window').width*0.1*((this.state.drawerMini==true)?0.5:1)),shadowOpacity: 0.6,shadowRadius: 2,shadowOffset: {height: 0,width: 0},elevation: 3}}>
                

                {this.state.vtcList.length>0 && <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",marginTop:10, fontWeight: 'bold',}}>{"Liste des VTC"}</Text>}
                {this.state.vtcList.length>0 && <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize*0.9,textAlign: "center", marginBottom:10,marginLeft:"5%", marginRight:"5%" }}>{"Dans votre zone de travail actuelle en fonction de leur priorisation"}</Text>}


                {this.state.vtcList.map(marker => (
                     <TextPresentation editable={false} text={marker.text} statusMode={(marker.onlineStatus=="raceInProgress")?"#FEA812" :((marker.onlineStatus=="offline")?style.backgroundColorContrast:"#4F8F00")} style={{marginTop:-10}} />
                  ))}


                {this.state.taxiList.length>0 && <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize*1.2,textAlign: "center",marginTop:10, fontWeight: 'bold',}}>{"Liste des taxis"}</Text>}
                {this.state.taxiList.length>0 && <Text style={{color: style.textInputColor,fontSize: style.textInputFontSize*0.9,textAlign: "center", marginBottom:10,marginLeft:"5%", marginRight:"5%" }}>{"Dans votre zone de travail actuelle en fonction de leur priorisation"}</Text>}


                {this.state.taxiList.map(marker => (
                     <TextPresentation editable={false} text={marker.text} statusMode={(marker.onlineStatus=="raceInProgress")?"#FEA812" :((marker.onlineStatus=="offline")?style.backgroundColorContrast:"#4F8F00")} style={{marginTop:-10}} textMini={(marker.status!=undefined)?((marker.status=="inZone")?("Dans la zone depuis "+((Date.parse(new Date())-marker.enterDate)/60000).toFixed(0)+" minutes" ):"Hors zone") :undefined} />
                  ))}
                
              </ScrollView>}






 
        </View>


        </Modal>

        <MavAlert ref={alert => {this.alert = alert;}}/>

        </View>

        }</StyleContext.Consumer>
      
      )}

    }


    export function generateUUID() {
  function s4() {
    return Math.floor((1 + Math.random()) * 0x10000)
      .toString(16)
      .substring(1);
  }
  return s4() + s4() + '-' + s4() + '-' + s4() + '-' +
    s4() + '-' + s4() + s4() + s4();
}

